import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import "./styles.css";
import { TransactionAction } from "../Store/Reducers/Transaction-reducer";
import { CustomerAction } from "../Store/Reducers/Customer-reducer";
import { useDispatch, useSelector } from "react-redux";
import GetCustomers from "../Store/Actions/GetCustomer-Action";
import { RestaurantAction } from "src/Store/Reducers/Restaurant-reducer";
const SearchComp = (props) => {
  const { endpoint, options, caller } = props;
  const [suggestion, setSuggestion] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const { loadMore } = useSelector((state) => state.Transaction);
  const { customerData, loading, isLoaded, status, PaginationToken } =
    useSelector((state) => state.Customer);
  console.log("loadMore>>", loadMore);

  const dispatch = useDispatch();

  const [body, setBody] = useState({
    key: "name",
    value: "",
  });

  const ref = useRef(null);

  const onClickOutside = useCallback(() => {
    setShow(false);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  const handleSearch = (value) => {
    let apiBody = { key: body.key, value };
    let postBody = options ? { search: apiBody } : { phone_number: value };
    postBody.limit = 50;
    console.log("caller", endpoint);
    if (caller === "transaction") {
      dispatch(TransactionAction.setLoadMore(true));
      axios
        .get(process.env.REACT_APP_API_URL + `${endpoint}=${value}`)
        .then((res) => {
          dispatch(TransactionAction.setSearchData(res.data));
          dispatch(TransactionAction.setLoadMore(false));
          dispatch(TransactionAction.setShowSearch(true));
        })
        .catch((err) => {
          dispatch(TransactionAction.setSearchData([]));
          dispatch(TransactionAction.setLoadMore(false));
          dispatch(TransactionAction.setShowSearch(true));
          console.log(err);
        });
    } else if (caller === "customer_search") {
      // setLoading(true);
      // setShow(true);
      dispatch(CustomerAction.setLoadMore(true));
      axios
        .post(process.env.REACT_APP_API_URL + endpoint, postBody)
        .then((res) => {
          setLoading(false);
          if (!options) {
            // let arrData = [];
            // arrData.push(res?.data);
            dispatch(CustomerAction.setSearching(true));
            dispatch(CustomerAction.searchData(res.data));
            // dispatch(CustomerAction.setLoading(true));
            dispatch(
              CustomerAction.setPaginationToken(res.data.PaginationToken || "")
            );
            dispatch(CustomerAction.setLoadMore(false));
            // dispatch(CustomerAction.setShowSearch(true));
            // setSuggestion(arrData);
          } else {
            // setSuggestion(res.data);
          }
        })
        .catch((err) => {
          // setLoading(false);
          // setSuggestion([]);
          dispatch(CustomerAction.setSearching(true));
          dispatch(CustomerAction.searchData([]));
          // dispatch(CustomerAction.setLoading(true));
          dispatch(CustomerAction.setPaginationToken(""));
          dispatch(CustomerAction.setLoadMore(false));
          console.log(err);
        });
    } else {
      setLoading(true);
      setShow(true);
      dispatch(RestaurantAction.setLoadMore(true));
      axios
        .post(process.env.REACT_APP_API_URL + endpoint, postBody)
        .then((res) => {
          // setLoading(false);
          // if (!options) {
          //   let arrData = [];
          //   arrData.push(res?.data);
          //   setSuggestion(arrData);
          // } else {
          //   setSuggestion(res.data);
          // }
          console.log("done", res);
          dispatch(RestaurantAction.setSearchRestaurant(res.data.data));
          dispatch(RestaurantAction.setLoadMore(false));
          dispatch(RestaurantAction.setShowSearch(true));
        })
        .catch((err) => {
          // setLoading(false);
          // setSuggestion([]);
          dispatch(RestaurantAction.setSearchRestaurant([]));
          dispatch(RestaurantAction.setLoadMore(false));
          dispatch(RestaurantAction.setShowSearch(true));
          console.log("errror", err);
        });
    }
  };

  const debouncing = (cb, seconds) => {
    let time;
    return function (...args) {
      if (time) clearTimeout(time);
      time = setTimeout(() => {
        cb(...args);
      }, seconds);
    };
  };

  const handleChange = debouncing((e) => {
    let value = e.target.value;
    console.log("value >", value);
    if (value.length === 0) {
      dispatch(CustomerAction.setCustomerList([]));
      dispatch(GetCustomers());
      setShow(false);
      dispatch(TransactionAction.setShowSearch(false));
      dispatch(RestaurantAction.setShowSearch(false));
    }
    if (suggestion.length > 0 && value.length > 0) setShow(true);
    setBody({ ...body, value });
    if (value.length > 0) handleSearch(value);
  }, 1000);

  const handleFocus = () => {
    if (body.value.length > 0 && caller !== "transaction") setShow(true);
  };

  return (
    <div ref={ref} className="searchDiv">
      <form
        className="searchForm"
        onSubmit={(e) => e.preventDefault()}
        onFocus={handleFocus}
      >
        <input type="text" placeholder="search...." onChange={handleChange} />
        <select
          className={!options ? "hideOptions" : undefined}
          value={body?.key}
          onChange={(e) => setBody({ ...body, key: e.target.value })}
        >
          <option value={"name"}>Restaurant Name</option>
          <option value={"slug"}>Slug</option>
          {/* <option value={"readable_id"}>Restaurant Id</option> */}
        </select>
      </form>
      {Loading && show && !(caller === "customer_search") && (
        // <div className="suggestionDiv">
        //   <Skeleton height={200} animation="wave" />
        //   <Skeleton height={200} animation="wave" />
        //   <Skeleton height={200} animation="wave" />
        //   <Skeleton height={200} animation="wave" />
        //   <Skeleton height={200} animation="wave" />
        //   <Skeleton height={200} animation="wave" />
        //   <Skeleton height={200} animation="wave" />
        // </div>
        ""
      )}
      {show && !Loading && !(caller === "customer_search") && (
        <div className="suggestionDiv">
          {suggestion.length > 0 ? (
            suggestion?.map((item, index) => (
              <Link
                className="link"
                to={
                  options
                    ? `restaurants/${item?._id}`
                    : `customers/${item?.sub}`
                }
                key={index}
              >
                {options
                  ? body.key === "slug"
                    ? item["_source"].slug
                    : `${item["_source"].name} (${item["_source"].slug})`
                  : item.name}
              </Link>
            ))
          ) : (
            <p className="link">no items found</p>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchComp;